import {ActionOnObject} from './ActionOnObject';

export class DeleteWallAction extends ActionOnObject {
  constructor(object) {
    super(object);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/actions/DeleteWallAction.ts